// GETTERS
export const GET_DOCTOR = 'doctor/GET_DOCTOR';
export const GET_DOCTOR_LIST = 'doctor/GET_DOCTOR_LIST';


// MUTATORS
export const MUTATE_LIST_DOCTOR = 'doctor/MUTATE_LIST_DOCTOR';


// ACTIONS
export const ACTION_LIST_DOCTORS = 'doctor/ACTION_LIST_DOCTORS';
export const ACTION_ADD = 'doctor/ACTION_ADD';
export const ACTION_UPDATE = 'doctor/ACTION_UPDATE';
export const ACTION_EDIT = 'doctor/ACTION_EDIT';


// WEBPACK FOOTER //
// ./src/store/constants/doctor.js